import React, { useCallback, useState } from 'react';
import { Modal, Button } from 'antd'
import { goLogin } from './exportUtil'

const OfflineUserModal = (props: any) => {
  const [visible, setVisible] = useState(true)

  const onOk = useCallback(() => {
    if (typeof goLogin === 'function') {
      goLogin()
    }
  }, [goLogin])

  // const onClose = useCallback(() => {
  //   setVisible(false)
  // }, [])

  return (
    <Modal
      visible={visible}
      closable={false}
      maskClosable={false}
      footer={null}
      width={400}
      getContainer={false}
    >
      <div className="star-offlineUser-modal star-base-modal">
        <div className="title">账号提示</div>
        <div className="text">
          <div><span className="span"></span>您的账号在其他设备上登录了，是否重新登录？</div>
        </div>
        {/* <div className="box">
          <Checkbox onChange={onChange}>我已阅读并同意星源<a className="link" href="/user-protocol" target="_blank">《用户服务协议》</a>和<a className="link" href="/privacy-protocol" target="_blank">《隐私政策》</a></Checkbox>
        </div> */}
        <div className="btn-area">
          <Button type="primary" onClick={onOk}>重新登录</Button>
        </div>
      </div>
    </Modal>
  )
}


export default React.memo(OfflineUserModal);